// @ngInject
Filters.HbtrustFilter  = function HbtrustFilter($filter, $sce) {
    return function(html) {
        return $sce.trustAsHtml(html);
    };
};